function initCookieNotice() {
  const banner = document.querySelector('[data-cookie-notice]');
  if (!banner) return;

  const cookieName = 'LBBWAMCookieNotice';
  if (document.cookie.split(';').some(cookie => cookie.trim().startsWith(`${cookieName}=`))) return;

  const button = banner.querySelector('[data-cookie-notice-accept]');
  const dialog = banner.querySelector('[role="dialog"]');
  const previousFocus = document.activeElement;
  const previousOverflow = document.body.style.overflow;

  banner.hidden = false;
  banner.classList.remove('cookieconsent__hidden');
  banner.classList.add('cookieconsent__visible');
  document.body.style.overflow = 'hidden';
  button.focus({ preventScroll: true });

  function keepFocus(event) {
    if (!dialog.contains(event.target)) button.focus({ preventScroll: true });
  }

  function handleKeydown(event) {
    // Escape dismisses the notice without recording acknowledgement.
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(dialog.querySelectorAll('a[href], button'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function close() {
    document.removeEventListener('focusin', keepFocus);
    dialog.removeEventListener('keydown', handleKeydown);
    banner.hidden = true;
    banner.classList.remove('cookieconsent__visible');
    banner.classList.add('cookieconsent__hidden');
    document.body.style.overflow = previousOverflow;
    if (previousFocus && previousFocus !== document.body && previousFocus.isConnected) {
      previousFocus.focus({ preventScroll: true });
    } else {
      const target = document.querySelector('main, [role="main"]') || document.body;
      const previousTabindex = target.getAttribute('tabindex');
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (previousTabindex === null) target.removeAttribute('tabindex');
      else target.setAttribute('tabindex', previousTabindex);
    }
  }

  document.addEventListener('focusin', keepFocus);
  dialog.addEventListener('keydown', handleKeydown);
  button.addEventListener('click', () => {
    const maxAge = 365 * 24 * 60 * 60;
    const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    try {
      document.cookie = `${cookieName}=1; Max-Age=${maxAge}; Expires=${expires}; Path=/; SameSite=Lax${secure}`;
    } finally {
      close();
    }
  });
}

if (document.readyState === 'complete') initCookieNotice();
else window.addEventListener('load', initCookieNotice, { once: true });
